import React from "react";
import Layout from "../components/Layout";

const PlanGoVideo = () => {
    return (
        <Layout title="Plan & Go Video" description="Preview of the Plan & Go Video">
            <div style={{ textAlign: "center", marginTop: "50px" }}>
                <h1 style={{ color: "#003D71", marginBottom: "20px" }}>Plan & Go Video</h1>
                <video
                    src="/videos/plan-go.mp4" 
                    controls
                    style={{
                        width: "100%",
                        maxWidth: "940px",
                        borderRadius: "10px",
                    }}
                />
            </div>
        </Layout>
    );
};

export default PlanGoVideo;
